// extracted by mini-css-extract-plugin
module.exports = {"backgroundImage":"index-module--backgroundImage--1Yiy1"};